var _rect, _mask, _rect2, _mask2, _rect3, _mask3, _rect4, _mask4, _rect5, _mask5, _rect6, _mask6, _rect7, _mask7, _rect8, _mask8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.3333,
    y: 64.166,
    width: 27.5,
    height: 27.5,
    rx: 2.57812,
    stroke: "#8B8987",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_9238_9540",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.5833,
    y: 59.584,
    width: 9.16666,
    height: 9.16666,
    rx: 0.859375
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5833,
    y: 59.584,
    width: 9.16666,
    height: 9.16666,
    rx: 0.859375,
    fill: "#8B8987",
    stroke: "#8B8987",
    strokeWidth: 6,
    mask: "url(#path-2-inside-1_9238_9540)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_9238_9540",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.9167,
    y: 59.584,
    width: 9.16667,
    height: 9.16666,
    rx: 0.859375
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.9167,
    y: 59.584,
    width: 9.16667,
    height: 9.16666,
    rx: 0.859375,
    fill: "#8B8987",
    stroke: "#8B8987",
    strokeWidth: 6,
    mask: "url(#path-3-inside-2_9238_9540)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_9238_9540",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.75,
    y: 68.75,
    width: 9.16666,
    height: 9.16666,
    rx: 0.859375
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68.75,
    y: 68.75,
    width: 9.16666,
    height: 9.16666,
    rx: 0.859375,
    fill: "#8B8987",
    stroke: "#8B8987",
    strokeWidth: 6,
    mask: "url(#path-4-inside-3_9238_9540)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-4_9238_9540",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.0833,
    y: 68.75,
    width: 9.16666,
    height: 9.16666,
    rx: 0.859375
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.0833,
    y: 68.75,
    width: 9.16666,
    height: 9.16666,
    rx: 0.859375,
    fill: "#8B8987",
    stroke: "#8B8987",
    strokeWidth: 6,
    mask: "url(#path-5-inside-4_9238_9540)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-5_9238_9540",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.9167,
    y: 77.916,
    width: 9.16667,
    height: 9.16667,
    rx: 0.859375
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 77.9167,
    y: 77.916,
    width: 9.16667,
    height: 9.16667,
    rx: 0.859375,
    fill: "#8B8987",
    stroke: "#8B8987",
    strokeWidth: 6,
    mask: "url(#path-6-inside-5_9238_9540)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-6_9238_9540",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.5833,
    y: 77.916,
    width: 9.16666,
    height: 9.16667,
    rx: 0.859375
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5833,
    y: 77.916,
    width: 9.16666,
    height: 9.16667,
    rx: 0.859375,
    fill: "#8B8987",
    stroke: "#8B8987",
    strokeWidth: 6,
    mask: "url(#path-7-inside-6_9238_9540)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-7_9238_9540",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.75,
    y: 87.084,
    width: 9.16666,
    height: 9.16666,
    rx: 0.859375
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 68.75,
    y: 87.084,
    width: 9.16666,
    height: 9.16666,
    rx: 0.859375,
    fill: "#8B8987",
    stroke: "#8B8987",
    strokeWidth: 6,
    mask: "url(#path-8-inside-7_9238_9540)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-8_9238_9540",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.0833,
    y: 87.084,
    width: 9.16666,
    height: 9.16666,
    rx: 0.859375
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 87.0833,
    y: 87.084,
    width: 9.16666,
    height: 9.16666,
    rx: 0.859375,
    fill: "#8B8987",
    stroke: "#8B8987",
    strokeWidth: 6,
    mask: "url(#path-9-inside-8_9238_9540)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3333,
    y: 18.334,
    width: 27.5,
    height: 27.5,
    rx: 2.57812,
    stroke: "#8B8987",
    strokeWidth: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1667,
    y: 18.334,
    width: 27.5,
    height: 27.5,
    rx: 2.57812,
    stroke: "#8B8987",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.351a2790c61a61540a7eb2cd169c9c68.svg";
export { ForwardRef as ReactComponent };